import { render, staticRenderFns } from "./prev_residence.vue?vue&type=template&id=082ce15b&"
import script from "./prev_residence.vue?vue&type=script&lang=js&"
export * from "./prev_residence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports